import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/layout/Header";
import { useAuth } from "../context/AuthContext";

export default function NoRoleAssigned() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleBackToLogin = () => {
    logout(); // clear tokens + user
    navigate("/", { replace: true });
  };

  return (
    <>
      <Header />

      <div style={{ padding: 40, textAlign: "center" }}>
        <h2>No Role Assigned</h2>

        <p style={{ marginTop: 12, fontSize: 16 }}>
          You have not been assigned to any role yet.
        </p>

        <p style={{ color: "#666", marginTop: 8 }}>
          Please contact the administrator to get access.
        </p>

        <button
          onClick={handleBackToLogin}
          style={{
            marginTop: 24,
            padding: "10px 20px",
            fontSize: 14,
            cursor: "pointer",
          }}
        >
          Back to Login
        </button>
      </div>
    </>
  );
}
